<template>
  <section>
    <b-container class="text-center">
    <img class="logo" src="/sendcloud-logo.svg"/>
    <!-- <h1>Sendcloud Marketing Demos</h1>
    <p>Use these interactive demos for your marketing or sales purposes. 🙌🏻</p> -->

    <b-list-group class="list">
    <router-link to="/notify/tracking-page"><b-list-group-item button>{{$t('Tracking page')}}</b-list-group-item></router-link>
    <router-link to="/shipping/shipping-rules"><b-list-group-item button>{{ $t('Shipping rules') }}</b-list-group-item></router-link>
    <router-link to="/shipping/incoming-orders"><b-list-group-item button>{{ $t('Incoming orders') }}</b-list-group-item></router-link>
    <router-link to="/returns/portal"><b-list-group-item button>{{ $t('Return portal') }}</b-list-group-item></router-link>
    <router-link to="/pack-go"><b-list-group-item button>Pack & Go</b-list-group-item></router-link>
    <router-link to="/checkout/dynamic-checkout"><b-list-group-item button>Dynamic Checkout</b-list-group-item></router-link>
    <b-list-group-item href="https://sendcloud.navattic.com/xmi049j">Monitor</b-list-group-item>
    <b-list-group-item href="https://sendcloud.navattic.com/t2a0mun">Issue Management</b-list-group-item>
  </b-list-group>
    <small>{{ $t('Questions or suggestions? Send an email to:') }} <a href="mailto:'contact@sendcloud.sc'">contact@sendcloud.sc</a></small>
    </b-container>
  </section>
</template>

<script>
import { BContainer, BListGroup, BListGroupItem } from 'bootstrap-vue';

export default {
  name: 'Home',
  components: {
    BContainer,
    BListGroup,
    BListGroupItem
  }
}

</script>
<style scoped>
section {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: bottom left / 20% url('https://faker.agency/sendcloud/images/blue-left.svg'), top right / 40% url('https://faker.agency/sendcloud/images/blue-right.svg');
  background-repeat: no-repeat;
}

.logo {
  max-width: 300px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.list {
  max-width: 450px;
  margin: 40px auto;
}

.list-group-item {
  border-bottom: none;
  border-radius: 0;
}

.list-group a:hover {
  text-decoration: none;
}

.list-group a:first-child .list-group-item {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.list-group a:last-child .list-group-item {
  border-bottom: 1px solid rgba(0,0,0,0.125);
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

</style>
